module.exports = __webpack_public_path__ + "68debd8c2998eea6bc746e4fd99a160e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/mp.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/mp.svg
// module chunks = 0